(function($) {	

// JS for Themes Taxonomy pages only
if ($('.tax-themes').length) { 
	// add villa count to destination overlay
	$('.hv-destFilter__modal__items .item').each(function(){
		var val = $(this).find('> span').text();
		var count = 0;
		$('.hv-villa').each(function(){
			if (val.includes($(this).data('destination'))) {
				count++;
			}
		});
		if (count==1) {
			$(this).find('b').parent().html('<b>1</b> Villa');			
		} else {
			$(this).find('b').text(count);			
		}
	});
}

})( jQuery ); 